import { useContext } from 'react';
import AppContext from './../contexts/AppContext';
import DataContext from '../contexts/DataContext';
import { appendScript, isMobile } from '../helpers';

import { useState } from 'react';
// import { Modal } from 'react-responsive-modal';
import { PopupModal } from 'react-calendly';

import icon from './../images/icon-calendar.svg';
import 'react-responsive-modal/styles.css';

export default function BookAppointment() {
  const {
    hideBookAppointment,
    setClickedBookAppointment,
    slfApiUrl,
    calendlyUrl,
  } = useContext(AppContext);
  const { data } = useContext(DataContext);
  const [modalOpen, setModalOpen] = useState(false);

  const onOpenModal = () => setModalOpen(true);
  const onCloseModal = () => setModalOpen(false);

  if (hideBookAppointment) return null;

  return (
    <>
      <a
        href=""
        onClick={(e) => {
          e.preventDefault();
          onOpenModal();
          if (data.leadId) {
            const updateuserMetaUrl = `${slfApiUrl}/api/user/update_lead_meta/${data.leadId}/clicked_book_an_appointment/1`;
            appendScript(updateuserMetaUrl);
          } else {
            setClickedBookAppointment(true);
          }
        }}
        className="flex items-center text-black text-[14px] bg-enph-orange px-[14px] py-[7px] rounded-full hover:opacity-80">
        <img alt="" src={icon} className="w-5 h-5 mr-2" />
        <span className={isMobile() ? '' : 'mt-1'}>
          Book
          <span className="hidden md:inline-block">&nbsp;an appointment</span>
        </span>
      </a>
      <PopupModal
        url={calendlyUrl}
        onModalClose={onCloseModal}
        open={modalOpen}
        rootElement={document.getElementById('root')!}
      />
      {/* <Modal
        open={modalOpen}
        onClose={onCloseModal}
        center
        classNames={{
          modal: 'w-full h-full md:w-[90%] md:h-[90%]',
        }}
        styles={{
          overlay: {},
          modal: {
            margin: 0,
            padding: '50px 0 0 0',
          },
          closeIcon: { width: '34px', height: '34px' },
        }}>
        <iframe
          title="meeting"
          src="https://meetings.hubspot.com/alyssa-cepeda/enphase-leads-program-solar-specialist-booking?embed=true"
          className="w-full h-full"></iframe>
      </Modal> */}
    </>
  );
}
